var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "progress-indicator-wrapper",
    },
    [
      _c("div", {
        staticClass: "progress-indicator",
        style: _vm.indicatorStyle,
      }),
      _vm._v(" "),
      _vm.hasDescription
        ? _c(
            "p",
            {
              staticClass: "progress-indicator-description",
            },
            [_vm._v("\n        " + _vm._s(_vm.description) + "\n    ")]
          )
        : _c(
            "p",
            {
              staticClass: "progress-indicator-description-default",
            },
            [_c("translate", [_vm._v("Lade...")])],
            1
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }